import {
  faChevronCircleUp,
  faChevronCircleDown,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Subtitle } from "../Subtitle/Subtitle";
import { Text } from "../Text/Text";
import * as styles from "./boxAccordion.module.scss";

interface Props {
  hashtag: string;
  title: string;
  text: string;
  comingsoon: string;
  subtitle: string;
  text1: string;
  text2: string;
  text3?: string;
  text4?: string;
  text5?: string;
  open: any;
  handleClick: any;
  index: number;
}

export const BoxAccordion: React.FC<Props> = ({
  hashtag,
  title,
  text,
  comingsoon,
  subtitle,
  text1,
  text2,
  text3 = "",
  text4 = "",
  text5 = "",
  open,
  index,
  handleClick,
}) => {
  return (
    <div className={styles.wrapper}>
      <div
        onClick={handleClick}
        className={
          open === index ? styles.titleAccordion : styles.titleAccordionOpen
        }
      >
        <div className={open === index ? styles.title : styles.titleOpen}>
          <Text className={styles.hashtag} text={hashtag} />
          <Text className={styles.text} text={title} />
        </div>
        <div className={styles.posIcon}>
          <FontAwesomeIcon
            icon={open === index ? faChevronCircleUp : faChevronCircleDown}
            className={styles.icon}
          />
        </div>
      </div>
      {open === index && (
        <div className={styles.overlap}>
          <div className={styles.panel}>
            <Text text={text} className={styles.panelText} />
            <Subtitle text={subtitle} className={styles.panelTitle} />
            <Text text={text1} className={styles.panelNumber} />
            <Text text={text2} className={styles.panelNumber} />
            {text3 && <Text text={text3} className={styles.panelNumber} />}
            {text4 && <Text text={text4} className={styles.panelNumber} />}
            {text5 && <Text text={text5} className={styles.panelNumber} />}
          </div>
          <div className={styles.backPanel}>
            <Text text={comingsoon} className={styles.panelTextComing} />
            <Text text={hashtag} className={styles.backHashtag} />
          </div>
        </div>
      )}
    </div>
  );
};
